import React from 'react';
import bg1 from '../img/envision/digital/digitalcards/application-engineering-solutions.webp'; // Adjust the path according to your project structure
import bg2 from '../img/envision/digital/digitalcards/manufacturing-operations-management-solutions.webp'; // Adjust the path according to your project structure
import bg3 from '../img/envision/digital/digitalcards/product-life-cycle-management-solutions.webp'; // Adjust the path according to your project structure

const Digitalcapabilityhovercards = () => {
  return (
    <div style={{ marginTop: '90px' }}>
      <h1 style={{ textAlign: "center" }}>
        <span style={{ color: 'rgb(5 134 162)' }}> Our Play in Digital  </span> Engineering
      </h1>

      {/* First Row */}
      <div className="two-side-cards-container">
        <div className="card">
          <h2 style={{ color: "#fff", fontWeight: 'bold' }}>Product Lifecycle Management</h2>
          <div className="card-image">
            <img src={bg1} alt="Image 1" />
          </div>
          <div className="card-hover-content">
            <p> Enable continuous evolution of your products with rapid design, production, and refinement to stay ahead of changing market needs.</p>
          </div>
        </div>

        <div className="card">
          <h2 style={{ color: "#fff", fontWeight: 'bold' }}>Manufacturing Operations Management</h2>
          <div className="card-image">
            <img src={bg2} alt="Image 2" />
          </div>
          <div className="card-hover-content">
            <p> Enable continuous evolution of your products with rapid design, production, and refinement to stay ahead of changing market needs.</p>
          </div>
        </div>

        <div className="card">
          <h2 style={{ color: "#fff", fontWeight: 'bold' }}>Service Management</h2>
          <div className="card-image">
            <img src={bg3} alt="Image 3" />
          </div>
          <div className="card-hover-content">
            <p> Enable continuous evolution of your products with rapid design, production, and refinement to stay ahead of changing market needs.</p>
          </div>
        </div>
      </div>

      <style jsx>{`
        .two-side-cards-container {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 50px;
          padding: 20px;
          flex-wrap: wrap;
        }

        .card {
          position: relative;
          width: 303px;
          height: 300px;
          text-align: center;
          background-color: #f0f0f0; /* Light background color */
          border-radius: 8px;
          overflow: hidden; /* Ensures content is contained within the card */
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Initial box-shadow */
        }

        .card:hover {
          transform: scale(1.05); /* Slightly scale the card on hover */
          box-shadow: 0 8px 16px rgba(0, 0, 0, 0.4); /* Increase box-shadow on hover */
        }

        .card::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.4); /* Semi-transparent black overlay */
          opacity: 0;
          transition: opacity 0.3s ease;
        }

        .card:hover::after {
          opacity: 0.3; /* Show overlay on hover */
        }

        .card h2 {
          position: absolute;
          bottom: 10px;
          left: 50%;
          transform: translateX(-50%);
          font-size: 20px;
          color: rgb(5, 134, 162);
          margin: 0;
          z-index: 1; /* Ensures title is above the image */
          transition: transform 0.3s ease, bottom 0.3s ease;
        }

        .card:hover h2 {
          transform: translateX(-50%) translateY(-100%); /* Move title to top on hover */
          bottom: auto; /* Remove bottom positioning */
          top: 0px; /* Position title at the top */
        }

        .card-image img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 8px;
        }

        .card-hover-content {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          visibility: hidden;
          opacity: 0;
          text-align: center;
          color: white;
          transition: visibility 0s, opacity 0.3s linear;
        }

        .card:hover .card-hover-content {
          visibility: visible;
          opacity: 1;
          width: 250px;
        }

        .card-hover-content p {
          font-size: 16px;
          font-weight: bold;
   
          padding: 10px;
          border-radius: 8px;
        }

        /* Media Query for Mobile Devices */
        @media (max-width: 768px) {
          .two-side-cards-container {
            flex-direction: column;
            gap: 30px;
            align-items: flex-start;
          }

          .card {
            width: 100%;
            height: auto;
          }

          h1 {
            font-size: 18px;
            text-align: center;
            margin-left: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default Digitalcapabilityhovercards;
